import { Dialog, DialogTitle, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { Input } from '@/components/catalyst-ui/input'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function CreateWorkspaceDialog({
  isOpen,
  onClose,
  workspaceName = '',
  onWorkspaceNameChange,
  onCreate,
  isCreating = false,
}) {
  return (
    <Dialog 
      open={isOpen} 
      onClose={onClose} 
      className="!rounded-xl !p-5 max-w-[512px]"
    >
      <div className="flex items-center justify-between mb-0">
        <DialogTitle>Name your Workspace</DialogTitle>
        <button
          onClick={onClose}
          disabled={isCreating}
          className="text-[#000000] hover:text-[#52525B] disabled:opacity-50 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-4">
        <div>
          <Input
            placeholder="Example: Company workspace"
            value={workspaceName}
            onChange={(e) => onWorkspaceNameChange(e.target.value)}
            disabled={isCreating}
            className="w-full"
          />
        </div>
      </DialogBody>
      <DialogActions className="!mt-4">
        <Button 
          outline 
          onClick={onClose} 
          disabled={isCreating}
          className="data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 !w-full"
        >
          Cancel
        </Button>
        <Button 
          color="dark" 
          onClick={onCreate} 
          disabled={!workspaceName.trim() || isCreating} 
          className="data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 !w-full"
        >
          {isCreating ? 'Creating...' : 'Create Workspace'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

